import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  verifications: [],
  total: 0,
  pages: 0,
  error: null,
  success: false,
  message: null,
};

export const verificationReducer = createReducer(initialState, {
  getVerificationDashboardRequest: (state) => { state.isLoading = true; },
  getVerificationDashboardSuccess: (state, action) => {
    state.isLoading = false;
    state.verifications = action.payload.verifications;
    state.total = action.payload.total;
    state.pages = action.payload.pages;
  },
  getVerificationDashboardFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  releasePaymentRequest: (state) => { state.isLoading = true; },
  releasePaymentSuccess: (state, action) => {
    state.isLoading = false;
    state.success = true;
    state.message = action.payload.message;
  },
  releasePaymentFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  approveQualityRequest: (state) => { state.isLoading = true; },
  approveQualitySuccess: (state, action) => {
    state.isLoading = false;
    state.success = true;
    state.message = action.payload.message;
  },
  approveQualityFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  createVerificationRequest: (state) => { state.isLoading = true; },
  createVerificationSuccess: (state, action) => {
    state.isLoading = false;
    state.success = true;
  },
  createVerificationFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  autoCheckRequest: (state) => { state.isLoading = true; },
  autoCheckSuccess: (state, action) => {
    state.isLoading = false;
    state.success = true;
    state.message = action.payload.message;
  },
  autoCheckFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  clearVerificationErrors: (state) => { state.error = null; },
  clearVerificationSuccess: (state) => { state.success = false; state.message = null; },
});
